import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=66e8831a"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e8831a')) {
      api.createRecord('66e8831a', component.options)
    } else {
      api.reload('66e8831a', component.options)
    }
    module.hot.accept("./LoaderOverlay.vue?vue&type=template&id=66e8831a", function () {
      api.rerender('66e8831a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/LoaderOverlay/LoaderOverlay.vue"
export default component.exports